import { IPagePanel, PagePanel } from "../common/pagePanel";

export const TaskStatisticsPanelId = "Task#Statistics";
export const TaskMyFiltersAndReportsPanelId = "Task#MyFiltersAndReports";
export const TaskStandardFiltersAndReportsPanelId = "Task#StandardFiltersAndReports";
export const TaskSharedFiltersAndReportsPanelId = "Task#SharedFiltersAndReports";

export class AppReportPagePanel extends PagePanel implements IPagePanel {
    static getPanelTitle(id: string): string {
        // switch (id) {
        // case TaskStatisticsPanelId:
        //     return Translations.Tasks;
        // case TaskMyFiltersAndReportsPanelId:
        //     return Translations.MyFiltersAndReports;
        // case TaskSharedFiltersAndReportsPanelId:
        //     return Translations.SharedFiltersAndReports;
        // case TaskStandardFiltersAndReportsPanelId:
        //     return Translations.StandardFiltersAndReports;
        // default:
        //     return "";
        // }
        return id;
    }

    getTitle(): string {
        // switch (this.panelType) {
        // case ContentPagePanelType.Statistics:
        //     return Translations.Tasks;
        // case ContentPagePanelType.MyFiltersAndReports:
        //     return Translations.MyFiltersAndReports;
        // case ContentPagePanelType.SharedFiltersAndReports:
        //     return Translations.SharedFiltersAndReports;
        // case ContentPagePanelType.StandardFiltersAndReports:
        //     return Translations.StandardFiltersAndReports;
        // default:
        //     return "";
        // }
        return this.panelType.toString(10);
    }
}